import { cn } from '@quadralize/utils'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckCircle } from '@solar-icons/react'
import * as React from 'react'
import { LabelWrapper } from '../label/label'

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    label?: string
    required?: boolean
    error?: boolean
    helperText?: React.ReactNode
  }
>(({ className, label, id, required, error, helperText, ...props }, ref) => {
  const generatedId = React.useId()
  const checkboxId = id || generatedId

  return (
    <LabelWrapper
      label={label}
      id={checkboxId}
      required={required}
      error={error}
      helperText={helperText}
      labelPosition="right"
      className="cursor-pointer"
    >
      <CheckboxPrimitive.Root
        id={checkboxId}
        ref={ref}
        required={required}
        className={cn(
          'peer h-4 w-4 shrink-0 rounded-sm border border-border-default focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focus-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-fg data-[state=checked]:border-primary',
          className,
        )}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          className={cn('flex items-center justify-center text-current')}
        >
          <CheckCircle className="h-3 w-3" weight="Bold" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
    </LabelWrapper>
  )
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
